export default __webpack_public_path__ + "images/cabin_bag_small.6141bd8.svg";